/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import * as XLSX from 'xlsx';
class CsvService {
   
    jsonToCsv(jsonData: Record<string, any>[]): string {
      const keys = Object.keys(jsonData[0]);
      const csvRows = [keys.join(',')];
  
      for (const data of jsonData) {
        const values = keys.map((key) => {
          const value = data[key];
          return isNaN(value) ? `"${value}"` : value;
        });
        csvRows.push(values.join(','));
      }
  
      return csvRows.join('\n');
    }
  
    
    downloadCsvFile(csvData: string, filename: string): void {
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

     // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    downloadXlsFile(jsonData:Record<string, any>[], filename: string) {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(jsonData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, filename);
    }
  }
  
  export default new CsvService();
  